import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Page } from "./types";
import ScrollToTop from "./ScrollToTop";
import PageHome from "containers/PageHome/PageHome";
import Page404 from "containers/Page404/Page404";
import ListingStayMapPage from "containers/ListingStayPage/ListingStayMapPage";

import CheckoutIndex from "containers/CheckOutPage";
import PayPage from "containers/PayPage/PayPage";
import PageSubcription from "containers/PageSubcription/PageSubcription";

import MainNav2 from "components/Header/MainNav2";
//import useWindowSize from "hooks/useWindowResize";

// Custom imports
import AdminForm from "containers/Admin/adminForm";
import SearchWidget from "containers/Widgets/searchWidget";
import BookingWidget from "containers/Widgets/bookingWidget";
import BookingQuoteWidget from "containers/Widgets/quoteWidget";
import CalendarWidget from "containers/Widgets/calendarWidget";
import BookingCalendarWidget from "containers/Widgets/BookingCalendarWidget";
import ListingPage from "containers/ListingStayPage/ListingsPage";
import ListingCalendarView from "containers/ListingStayPage/ListingCalendarView";
import { BookingProvider } from "context/BookingContext";
import ListingDetailPage from "containers/ListingDetailPage/listing-stay-detail/ListingDetailPage";

import ListingResolverBeta from "containers/ListingStayPage/ListingResolverBeta";

export const pages: Page[] = [
  { path: "/", exact: true, component: PageHome },
  { path: "/#", exact: true, component: PageHome },
  { path: "/listings-list", component: ListingPage },
  { path: "/listings-Calendar", component: ListingCalendarView },
  { path: "/listing-stay-map", component: ListingStayMapPage },
  { path: "/listing-guesty/:id", component: ListingDetailPage },
  { path: "/listings", component: ListingResolverBeta },
  { path: "/listings-list/:id", component: ListingDetailPage },


// BETA IFRAME INCLUDE INTERAL ID IN URL
  { path: "/integration", component: ListingResolverBeta },


  ///search page 
  { path: "/search/:checkIn/:checkOut/:guestsCount/:location?", component: ListingPage },
  { path: "/search/:checkIn/:checkOut/:guestsCount/:location?/:id", component: ListingDetailPage },
  {
    path: "/checkout/:listingID/:currency/:arrival/:departure/:guests/:internalId?/:couponCode?",
    component: CheckoutIndex,
  },
  { path: "/pay-done", component: PayPage },
  { path: "/admin", component: AdminForm },
  { path: "/subscription", component: PageSubcription },
  { path: "/searchwidget", component: SearchWidget },
  { path: "/bookingwidget", component: BookingQuoteWidget },
  { path: "/calendarwidget", component: BookingCalendarWidget },
];

const MyRoutesLogic = () => {
  const location = useLocation();
  const noHeaderFooterRoutes = ["/searchwidget", "/calendarwidget", "/bookingwidget"];
  const hideHeaderFooter = noHeaderFooterRoutes.includes(location.pathname);
  //const WIN_WIDTH = useWindowSize().width || (typeof window !== "undefined" ? window.innerWidth : 0);

  return (
    <>
      {/* Conditionally render header */}
      {!hideHeaderFooter && (
        
          <MainNav2 />
      
      )}

      <Routes>
        {pages.map(({ component, path }) => {
          const Component = component;
          return <Route key={path} element={<Component />} path={path} />;
        })}
        <Route path="*" element={<Page404 />} />
      </Routes>

      {/* Conditionally render footer 
      {!hideHeaderFooter && (
        <>
          {WIN_WIDTH < 768 && <FooterNav />}
         
        </>
      )}
        */}
    </>
  );
};

const MyRoutes = () => (
  <BookingProvider>
    <ScrollToTop />
    <MyRoutesLogic />
  </BookingProvider>
);

export default MyRoutes;